export var Events;
(function (Events) {
    Events[Events["UpdateView"] = 0] = "UpdateView";
    Events[Events["DeleteView"] = 1] = "DeleteView";
    Events[Events["UpdateViewsTree"] = 2] = "UpdateViewsTree";
    Events[Events["RequestViewsTree"] = 3] = "RequestViewsTree";
    Events[Events["RespondToEvent"] = 4] = "RespondToEvent";
    Events[Events["RequestEvent"] = 5] = "RequestEvent";
})(Events || (Events = {}));
export var EventContent;
(function (EventContent) {
    EventContent[EventContent["Data"] = 0] = "Data";
    EventContent[EventContent["Uid"] = 1] = "Uid";
    EventContent[EventContent["EventUid"] = 2] = "EventUid";
    EventContent[EventContent["ParentUid"] = 3] = "ParentUid";
    EventContent[EventContent["ChildIndex"] = 4] = "ChildIndex";
    EventContent[EventContent["isRoot"] = 5] = "isRoot";
    EventContent[EventContent["EventArgs"] = 6] = "EventArgs";
    EventContent[EventContent["View"] = 7] = "View";
    EventContent[EventContent["Views"] = 8] = "Views";
    EventContent[EventContent["Props"] = 9] = "Props";
    EventContent[EventContent["Create"] = 10] = "Create";
    EventContent[EventContent["Merge"] = 11] = "Merge";
    EventContent[EventContent["Delete"] = 12] = "Delete";
    EventContent[EventContent["Name"] = 13] = "Name";
    EventContent[EventContent["Type"] = 14] = "Type";
    EventContent[EventContent["Event"] = 15] = "Event";
})(EventContent || (EventContent = {}));
//# sourceMappingURL=enum.js.map